<template>
  <div>
    <el-card class="chart-card">
      <h1>开始使用</h1>
      <p>
        <el-text tag="b">第一步：</el-text>
        <el-text>使用Maven引入Pignoo依赖。</el-text>
      </p>
      <div>
        <pre><code class="language-xml">{{ code1 }}</code></pre>
      </div>
      <p>
        <el-text tag="b">第二步：</el-text>
        <el-text>编写一个与数据库对应的实体。</el-text>
      </p>
      <div>
        <pre><code class="language-java">{{ code2 }}</code></pre>
      </div>
      <p>
        <el-text tag="b">第三步：</el-text>
        <el-text>用任何你喜欢的方法，创建一个DataSource。如果你使用SpringBoot，引入spring-boot-starter-jdbc后就会默认构建好单例的DataSource的SpringBean。</el-text>
        <br />
        <el-text>由于Spring环境下代码简洁易于理解，后续例子默认按照Spring容器环境下的写法举例。</el-text>
        <br />
        <el-text>但Spring不是必须的，构造成SpringBean的，说明它是允许单例的，其他环境可以使用public static来变量代替。</el-text>
      </p>
      <p>
        <el-text tag="b">第四步：</el-text>
        <el-text>尝试一个简单Demo，访问数据库。由于Pignoo是一个需要关闭的（将当前JDBC连接关闭或返回连接池），可以使用try-with-resources。</el-text>
        <el-text>但是这么写有些繁琐，且不支持事务，我们后续使用Gru或Spring-Pignoo改进它。</el-text>
      </p>
      <div>
        <pre><code class="language-java">{{ code3 }}</code></pre>
      </div>
      <p>
        <el-text tag="b">第五步：</el-text>
        <el-text>使用Gru改造上面Demo，让他变得更安全，且支持事务，生产环境就可以这么写了！</el-text>
        <el-text tag="b">恭喜你🎉做到这里，你已经入门了Pignoo！</el-text>
      </p>
      <div>
        <pre><code class="language-java">{{ code4 }}</code></pre>
      </div>
      <div>
        <pre><code class="language-java">{{ code5 }}</code></pre>
      </div>
    </el-card>
  </div>
</template>

<script setup>
import { onMounted } from 'vue'

onMounted(() => {
  if (window.hljs) {
    window.hljs.highlightAll()
  }
})

const code1 = `<dependency>
  <groupId>com.xuesinuo</groupId>
  <artifactId>pignoo-core</artifactId>
  <version>1.1.6</version>
</dependency>`

const code2 = `@Data
@Table("pig") // 数据库表名
public class Pig {
  @Column(value="id", primaryKey=PrimaryKey.AUTO) // 数据库主键列
  private Long id;
  @Column(value="name") // 数据库普通列
  private String name;
}`

const code3 = `@Component
public class Demo {
  @Autowired
  private DataSource dataSource;

  public void add() {
    try(Pignoo pignoo = new BasePignoo(dataSource)) {
      Pig pig = new Pig();
      pig.setName("新的小猪");

      PignooWriter writer = pignoo.writer(Pig.class); // 加载指定实体对应的表；writer是读写操作器
      writer.removeAll(); // 清空List。对应数据库操作：Delete操作
      Pig newPig = writer.add(pig); // 元素加入List。对应数据库操作：Insert操作，同时会返回插入后的元素
      System.out.println(newPig.getId());
      newPig.setName("换个名字"); // 修改集合中的元素。对应数据库：Update操作

      pig.setName("这个名字存不到数据库"); // newPig是“从集合中获取的”，会映射数据库；pig是“在内存中创建的”，不会映射数据库。这一点和List略有不同

      PignooReader reader = pignoo.reader(Pig.class); // reader是只读操作器
      List<Pig> pigs = reader.getAll(); // 读取全部数据
      System.out.println(pigs);
    }
  }
}`

const code4 = `// 全局共用的Gru实体，
@Configuration
public class GruConfig {
  @Bean
  Gru gru(@Autowired DataSource dataSource) {
    return new Gru(dataSource);
  }
}`

const code5 = `@Component
public class Demo {
  @Autowired
  private Gru gru;

  public void add() {
    gru.runTransaction(pignoo -> {
      // 此处写上面Demo中try块内容，相比之下多了事务
    });
  }
}`

</script>

<style lang="less"></style>